var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji54(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M36 18c0 9.941-8.059 18-18 18-9.94 0-18-8.059-18-18C0 8.06 8.06 0 18 0c9.941 0 18 8.06 18 18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7892",
    cx: 29,
    cy: 23,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7892",
    cx: 7,
    cy: 23,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 24.5,
    cy: 16.5,
    r: 5.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 11.5,
    cy: 16.5,
    r: 5.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 11.5,
    cy: 16.5,
    r: 2.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 24.5,
    cy: 16.5,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M22 30h-8c-.552 0-1-.447-1-1s.448-1 1-1h8c.553 0 1 .447 1 1s-.447 1-1 1zm8.001-19c-.305 0-.604-.138-.801-.4-2.64-3.521-6.061-3.598-6.206-3.6-.55-.006-.994-.456-.991-1.005C22.006 5.444 22.45 5 23 5c.184 0 4.537.05 7.8 4.4.332.442.242 1.069-.2 1.4-.18.135-.39.2-.599.2zM5.999 11c-.208 0-.419-.065-.599-.2-.442-.331-.531-.958-.2-1.4C8.462 5.05 12.816 5 13 5c.552 0 1 .448 1 1 0 .551-.445.998-.996 1-.155.002-3.568.086-6.204 3.6-.196.262-.497.4-.801.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji54);
export default __webpack_public_path__ + "static/media/emoji54.a78cb3d395b95e16ab432a2aed14ec7f.svg";
export { ForwardRef as ReactComponent };